var featuresVideoGrid = require('../common/featuresVideoGrid.js')

module.exports = function() {
    const $el = $('.experience-commerce_assets-rykVideoGrid');
    featuresVideoGrid.initVideoGrid($el)
}

